import React, { useState } from "react";
import ManageDevicesModal from "./manage-devices-modal";
import {
  LearnerBiometricsProviders,
  LearnerBiometricsProvider,
  LearnerBiometrics,
} from "apps/user/learner/api/types";
import { useBiometricsModal } from "providers/biometrics-modal";
import { Button } from "components/ui";
import { useTranslation } from "lib/i18n/use-translation";

import styles from "./styles.module.scss";
interface DeviceTileProps {
  handleOpen: (value, item) => void;
  data: LearnerBiometricsProvider;
}

interface ManageDevicesProps {
  provider: LearnerBiometricsProviders;
  hasHealthData: LearnerBiometrics["hasHealthData"];
}

const DeviceTile = ({ handleOpen, data }: DeviceTileProps) => {
  const { t } = useTranslation(["settings"]);
  return (
    <div className={styles["content"]}>
      <p>{data.name}</p>
      <Button
        variant="enclosed-secondary"
        onClick={() => handleOpen("remove-device", data)}
      >
        {t("settings:manageDevices.remove")}
      </Button>
    </div>
  );
};

const NoConnectedDevice = () => {
  const { t } = useTranslation(["settings"]);
  return (
    <div className={styles["no-device"]}>
      <h2>{t("settings:manageDevices.emptyTitle")}</h2>
      <p>{t("settings:manageDevices.emptySubtitle")}</p>
    </div>
  );
};

const ManageDevices = ({ provider, hasHealthData }: ManageDevicesProps) => {
  const { t } = useTranslation(["settings"]);
  const [isOpen, setIsOpen] = useState(false);
  const { onOpen } = useBiometricsModal();
  const [modalData, setModalData] = useState(null);

  const handleOpen = (value, item) => {
    setModalData({
      type: value,
      item: item,
    });
    setIsOpen(true);
  };

  const { title, providers } = provider;

  return (
    <div className={styles["manage-devices"]}>
      <h1 className={styles["title"]}>{title}</h1>
      <div
        className={
          providers.length > 0
            ? styles["device-container"]
            : styles["no-device-container"]
        }
      >
        {providers.length > 0 ? (
          providers.map((item) => (
            <DeviceTile key={item.id} handleOpen={handleOpen} data={item} />
          ))
        ) : (
          <NoConnectedDevice />
        )}
        <div className={styles["footer-buttons"]}>
          <Button
            variant="enclosed-primary"
            className={styles["source-device"]}
            disabled={providers.length > 0}
            onClick={onOpen}
          >
            {t("settings:manageDevices.connectDevice")}
          </Button>
          {hasHealthData && (
            <Button
              variant="secondary"
              onClick={() => handleOpen("remove-data", null)}
              className={styles["delete-button"]}
            >
              {t("settings:manageDevices.deleteHealthData")}
            </Button>
          )}
        </div>
      </div>
      <ManageDevicesModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        modalData={modalData}
        setModalData={setModalData}
      />
    </div>
  );
};

export default ManageDevices;
